// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAPq8PoYSwdt95F9DtVmBsmYWOfC2PQE_k",
  authDomain: "werebiam.firebaseapp.com",
  projectId: "werebiam",
  storageBucket: "werebiam.firebasestorage.app",
  messagingSenderId: "522762210136",
  appId: "1:522762210136:web:3a214b855484bd01ebb32d",
  measurementId: "G-JMFL70GQEF"
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };